import axios from 'axios';

import { isDemoZone } from '../../components/demo/constants';
import { useGlobalStore } from '../../stores/useGlobalStore';

const axiosInstance = axios.create({ baseURL: process.env.BASE_URL });
const authenticatedAxiosInstance = axios.create({ baseURL: process.env.BASE_URL });

// Public instance: carry the demo cookie only inside the demo zone.
axiosInstance.interceptors.request.use((config) => {
  config.withCredentials = isDemoZone;
  return config;
});

authenticatedAxiosInstance.interceptors.request.use((config) => {
  // Demo zone authenticates with the demo cookie only — never the PropelAuth
  // token. Normal zone authenticates with the PropelAuth token only — never
  // the cookie.
  if (isDemoZone) {
    config.withCredentials = true;
    delete config.headers['Authorization'];
    return config;
  }

  config.withCredentials = false;
  const { accessToken, isStaging } = useGlobalStore.getState();
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    if (isStaging) {
      config.headers['projectWorkflowState'] = 'staging';
      config.headers['compassmoduleworkflowstate'] = 'staging';
    } else {
      delete config.headers['compassmoduleworkflowstate'];
      delete config.headers['projectWorkflowState'];
    }
  }
  return config;
});

authenticatedAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config } = error;
    if (error.response?.status === 401 && !config._retry) {
      config._retry = true;
      return authenticatedAxiosInstance(config);
    }
    return Promise.reject(error);
  }
);

export const makeGetRequest = axiosInstance.get;
export const makePostRequest = axiosInstance.post;

export const makeAuthenticatedGetRequest = authenticatedAxiosInstance.get;
export const makeAuthenticatedPostRequest = authenticatedAxiosInstance.post;
export const makeAuthenticatedPutRequest = authenticatedAxiosInstance.put;
